import * as Nested from "../../../util/Nested";
import FilterToolbarForm from "@/components/administeredUsers/FilterToolbarForm";
import MultiSelectFilterForm from "../MultiSelectFilterForm";

const initialState = {};

export const FILTER_TOOLBAR_FORM_ACTION =
  "administeredUsersFilters/FILTER_TOOLBAR_FORM_ACTION";

export const filterToolbarFormAction = Nested.nestedAction(
  FILTER_TOOLBAR_FORM_ACTION
);

export const MULTIPLE_SELECT_FILTER_FORM_ACTION =
  "administeredUsersFilters/MULTIPLE_SELECT_FILTER_FORM_ACTION";

export const multipleSelectFilterFormAction = Nested.nestedAction(
  MULTIPLE_SELECT_FILTER_FORM_ACTION
);

const _reducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export const _mapStateToProps = () => {};
export const _mapDispatchToProps = () => {};

const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
  actions,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps,
  },
  {
    forms: {
      filterToolbarForm: {
        ...FilterToolbarForm,
        actionType: FILTER_TOOLBAR_FORM_ACTION,
      },
      multiSelectFilterForm: {
        ...MultiSelectFilterForm,
        actionType: MULTIPLE_SELECT_FILTER_FORM_ACTION,
      },
    },
  },
  "administeredUsersFilters"
);

const reducer = (state, action) => nestedReducer(state, action);

export { reducer, mapStateToProps, mapDispatchToProps, actions };
